import { apiClient } from "@/helpers/apiClient";
import userSelector from "@/store/selectors/userSelector";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useGetActiveMunicipality, useGetMunicipalities } from "@/helpers/getMunicipality";
import { getMunicipalityImagePath } from "@/helpers/imageUrls";

type BlobGet = (url: string, config: { responseType: 'blob' }) => Promise<{ data: Blob }>;

// This will be rewritten in future to support image urls across any contract
const useMunicipalityImageUrl = (): string | null => {
    const [imageObjectUrl, setImageObjectUrl] = useState<string | null>(null);

    const user = useSelector(userSelector);
    const { data: municipalities } = useGetMunicipalities();
    const municipalityId = useGetActiveMunicipality();
    const isClientUser = !!user && user.type !== "admin";

    const municipality = municipalities?.find((m) => m.id === municipalityId);
    const municipalityImagePath = municipality ? getMunicipalityImagePath(municipality) : undefined;
    
    // Load building image as blob to handle authentication
    useEffect(() => {
        let objectUrl: string | null = null;

        if (municipalityImagePath) {
            const loadImage = async () => {
            try {
                const getBlob = apiClient.get as unknown as BlobGet;
                const response = await getBlob(
                municipalityImagePath,
                { responseType: 'blob' }
                );
                objectUrl = URL.createObjectURL(response.data);
                setImageObjectUrl(objectUrl);
            } catch {
                // Failed to load image, will show avatar fallback
                setImageObjectUrl(null);
            }
            };
            loadImage();

            // Cleanup object URL on unmount or when building changes
            return () => {
            if (objectUrl) {
                URL.revokeObjectURL(objectUrl);
            }
            };
        } else {
            setImageObjectUrl(null);
        }
    }, [municipalityImagePath]);

    return isClientUser ? imageObjectUrl : null;
};

export default useMunicipalityImageUrl;
